<template>
  <el-select
    v-bind="$attrs"
    v-model="selectedValue"
    filterable
    clearable
    :placeholder="placeholder"
    v-on="$listeners"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :disabled="item.disabled"
    />
    <template #[slotName] v-for="(slot, slotName) in $slots">
      <slot :name="slotName"></slot>
    </template>
  </el-select>
</template>

<script>
  import { getPositionList } from '@/api/office/position'
  export default {
    name: 'YdPostSelect',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      placeholder: {
        type: String,
        default: '请选择'
      }
    },
    data() {
      return {
        options: []
      }
    },
    computed: {
      selectedValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        const { code, data } = await getPositionList()
        if (code !== 0 || !Array.isArray(data)) {
          return
        }
        this.options = data
      }
    }
  }
</script>

<style lang="scss" scoped></style>
